import React from "react";
import StoresQueryCard from "./StoresQueryCard";
import WorkOrderResults from "./WorkOrderResults";
import { findWorkOrder } from "../api/WorkOrders";
import { encodeParam } from "../util/ApiHelper";
import { StoresProps } from "../models/stores/Stores";
import { ModuleNames } from "../util/Constants";

const StoresWorkOrder: React.FC<StoresProps> = (props) => {
  return (
    <StoresQueryCard
      {...props}
      module={ModuleNames.WorkOrder}
      querySection="QW--Work Order"
      placeholder="Enter Work Order Number"
      advancedSearchLabel="Advanced Search"
      cardTitle="Work Order"
      popoverSearch={async (val) => {
        const res = await findWorkOrder(val);
        return res.status === 200 ? res.data.map((w: any) => w.WoNumber) : [];
      }}
      onBarcodeScan={async (text: any, storesTab: any, router: any, presentAlert: any) => {
        if (text) {
          const res = await findWorkOrder(text);
          if (res.status === 200 && res.data.length > 0) {
            router.push(`/workorder/${encodeParam(text)}/${storesTab}material`);
          } else {
            presentAlert({
              message: "Work Order could not be found",
              buttons: ["OK"],
            });
          }
        } else {
          presentAlert({
            message: "Work Order could not be found",
            buttons: ["OK"],
          });
        }
      }}
      ResultsComponent={WorkOrderResults}
    />
  );
};

export default StoresWorkOrder;